import { ref, computed } from "vue";

export function useFilterTags(showSectionCover = true) {
  const filterTags = ref<{ filter: string; label: string; count?: number }[]>([]);

  const hasFilterTags = computed(() => filterTags.value.length > 0);

  const filteredFilterTags = computed(() => {
    if (!showSectionCover) {
      return filterTags.value.filter((tag) => tag.filter !== "section");
    }
    return filterTags.value;
  });

  const addSingleTag = (filterName: string, tagName: string) => {
    const existTag = filterTags.value.find((tag) => tag.label === tagName);
    if (!existTag) {
      filterTags.value.push({ filter: filterName, label: tagName });
    }
  };

  const addMultiTag = (
    filterName: string,
    tags: { label: string }[] = [],
    filterLabel?: string,
  ) => {
    if (tags.length === 1) {
      addSingleTag(filterName, tags[0].label);
    } else {
      filterTags.value.push({
        filter: filterName,
        label: filterLabel || filterName,
        count: tags.length,
      });
    }
  };

  const removeTag = (filterName: string) => {
    filterTags.value = filterTags.value.filter((tag) => tag.filter !== filterName);
  };

  const resetTags = () => {
    filterTags.value = [];
  };

  return {
    filterTags,
    hasFilterTags,
    filteredFilterTags,
    addSingleTag,
    addMultiTag,
    removeTag,
    resetTags,
  };
}
